module.exports = __webpack_public_path__ + "static/media/hero-bg.77f38dc3.jpg";